import React from 'react';
import Input from './input';

export default class FileInput extends React.Component {
  render() {
    return <Input type="file" {...this.props} />;
  }
}
